// @flow
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'

import { useFormErrorStyles } from './styles'

type ControllerErrorProps = {
  name: string
}

const ControllerError = ({ name }: ControllerErrorProps) => {
  const classes = useFormErrorStyles()
  const { errors } = useFormContext()

  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message, messages }) => {
        if (messages) {
          return Object.keys(messages).map(key => {
            const [type, message] = messages[key]
            return (
              <p key={type} className={classes.formError}>
                {message}
              </p>
            )
          })
        }
        return <p className={classes.formError}>{message}</p>
      }}
    />
  )
}

export { ControllerError }
